import React, { Component, forwardRef } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import LinearProgress from "@mui/material/LinearProgress";
import {
  Typography,
  Link,
  Box,
  Stack,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
// import Container from '@material-ui/core/Container';
import Logo from "../images/logo120.png";
import CircularProgress from "@mui/material/CircularProgress";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircle from "@mui/icons-material/AccountCircle";
import AuthLayout from "../layouts/AuthLayout";
import Snackbar from "@mui/material/Snackbar";
import { Portal } from "@mui/base";
import {
  Link as RouterLink,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
// components
import { MHidden } from "../components/@material-extend";
import { useState, useRef, useEffect } from "react";
import MuiAlert from "@mui/material/Alert";
import Page from "../components/Page";
import Slide from "@mui/material/Slide";
import { CallApi } from "../statics.js";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

// export default class Login extends Component {
export default function SetPassword() {
  const [currentPasswordErrorText, setCurrentPasswordErrorText] = useState("");
  const [passwordErrorText, setPasswordErrorText] = useState("");
  const [repasswordValue, setRepasswordValue] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [currentPasswordValue, setCurrentPasswordValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const [repasswordErrorText, setRepasswordErrorText] = useState("");
  const [registerErrorText, setRegisterErrorText] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);

  const cPassInput = useRef();
  const passInput = useRef();
  const repassInput = useRef();

  const navigate = useNavigate();
  const { state } = useLocation();

  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    cPassInput.current.focus();
  }, [buttonDisabled]);

  const onCreateAccount = () => {
    setRegisterErrorText("");
    if (!currentPasswordValue) {
      setCurrentPasswordErrorText("please enter your current password");
      cPassInput.current.focus();
      return;
    } else {
      setCurrentPasswordErrorText("");
    }

    if (!passwordValue) {
      setPasswordErrorText("please enter your new password");
      passInput.current.focus();
      return;
    } else {
      setPasswordErrorText("");
    }

    if (!repasswordValue) {
      setRepasswordErrorText("please repeat your new password");
      repassInput.current.focus();
      return;
    } else {
      setRepasswordErrorText("");
    }

    if (repasswordValue !== passwordValue) {
      setRepasswordErrorText("password is not match");
      repassInput.current.focus();
      return;
    } else {
      setRepasswordErrorText("");
    }

    // let usernameValue = state.username;

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      cpassword: currentPasswordValue,
      npassword: passwordValue,
    };
    setButtonDisabled(true);

    console.log(data);
    CallApi("changePassword", "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            // setCookie("token", result.token, 365);
            // setCookie("username", usernameValue, 365);
            navigate("/");
            return;
          } else {
            setRegisterErrorText(result.message);
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const handleKeyPress = (target) => {
    if (target.charCode === 13) {
      onCreateAccount();
    }
  };

  return (
    <Page title="Change Password | Admin Panel">
      <Box
        sx={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Box className="loginForm">
          <Box className="logoContainer">
            <img
              src={Logo}
              alt=""
              style={{
                width: "65px",
                objectFit: "contain",
              }}
            />
          </Box>

          <div className="paper">
            <Box className="form">
              <div style={{ minHeight: "20px" }} />
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                autoFocus
                name="currentPasswordValue"
                label="Current Password"
                type="password"
                id="currentpassword"
                color="primary"
                helperText={currentPasswordErrorText}
                error={currentPasswordErrorText ? true : false}
                value={currentPasswordValue}
                onChange={(e) => setCurrentPasswordValue(e.target.value)}
                disabled={buttonDisabled}
                onKeyPress={handleKeyPress}
                inputRef={cPassInput}
              />
              <div style={{ minHeight: "20px" }} />
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                name="passwordValue"
                label="New Password"
                type="password"
                id="password"
                color="primary"
                helperText={passwordErrorText}
                error={passwordErrorText ? true : false}
                value={passwordValue}
                onChange={(e) => setPasswordValue(e.target.value)}
                disabled={buttonDisabled}
                onKeyPress={handleKeyPress}
                inputRef={passInput}
              />
              <div style={{ minHeight: "20px" }} />
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                name="repasswordValue"
                label="Confirm New Password"
                type="password"
                id="repassword"
                color="primary"
                helperText={repasswordErrorText}
                error={repasswordErrorText ? true : false}
                value={repasswordValue}
                onChange={(e) => setRepasswordValue(e.target.value)}
                disabled={buttonDisabled}
                onKeyPress={handleKeyPress}
                inputRef={repassInput}
              />
              <div style={{ minHeight: "20px" }} />
              {registerErrorText && (
                <Box sx={{ width: "100%" }}>
                  <MuiAlert variant="filled" severity="error">
                    {registerErrorText}
                  </MuiAlert>
                </Box>
              )}
              <Box style={{ minHeight: "10px" }} />
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className="submit"
                disabled={buttonDisabled}
                onClick={onCreateAccount}
              >
                Change Password
              </Button>
              <div style={{ minHeight: "10px" }} />
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                className="submit"
                disabled={buttonDisabled}
                to={"/steps"}
                component={RouterLink}
              >
                Cancel
              </Button>
            </Box>
          </div>
          {buttonDisabled && (
            <LinearProgress
              color="primary"
              style={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                marginLeft: "-20px",
              }}
            />
          )}
        </Box>
      </Box>
      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
  // } else {
  //   return <Navigate to="/register" replace />;
  // }
  // }
}
